import { defineFreeTextFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const keywordsDescriptor = defineFreeTextFilter({
  definition: {
    id: FilterId.KEYWORDS,
    name: 'Keywords',
    text: [],
    type: FilterType.FREE_TEXT,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_KEYWORDS },
});
